export enum UpdateTemplateType {
  All = 0,
  Name = 1,
  Content = 2,
  Status = 3,
}
